export function formatRtp(rtp) {
  if (!rtp) return '—';
  const n = parseFloat(rtp);
  return isNaN(n) ? rtp : `${n.toFixed(0)}%`;
}

/** "$1,000.00", "€2,502.50" — thousands separators, always two decimals.
 *  An unknown currency code falls back to "XYZ 1,000.00". */
export function formatMinBet(amount, currency = 'USD') {
  if (!amount) return '—';
  const n = parseFloat(amount);
  if (isNaN(n)) return String(amount);
  const code = (currency || 'USD').toUpperCase();
  try {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: code, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n);
  } catch {
    return `${code} ${new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)}`;
  }
}
